var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00305 12H14.2531L11.0031 8.75L11.6671 8L16.1671 12.5L11.6671 17L11.0031 16.25L14.2531 13H6.00305V12ZM21.0031 12.5C21.0031 13.7476 20.7573 14.9829 20.2799 16.1355C19.8025 17.2881 19.1027 18.3354 18.2206 19.2175C17.3384 20.0997 16.2911 20.7994 15.1385 21.2769C13.986 21.7543 12.7506 22 11.5031 22C10.2555 22 9.02015 21.7543 7.86756 21.2769C6.71497 20.7994 5.66769 20.0997 4.78554 19.2175C3.90338 18.3354 3.20362 17.2881 2.7262 16.1355C2.24878 14.9829 2.00305 13.7476 2.00305 12.5C2.00305 9.98044 3.00394 7.56408 4.78554 5.78249C6.56713 4.00089 8.9835 3 11.5031 3C14.0226 3 16.439 4.00089 18.2206 5.78249C20.0022 7.56408 21.0031 9.98044 21.0031 12.5ZM20.0031 12.5C20.0031 10.2457 19.1075 8.08365 17.5135 6.48959C15.9194 4.89553 13.7574 4 11.5031 4C9.24871 4 7.0867 4.89553 5.49264 6.48959C3.89858 8.08365 3.00305 10.2457 3.00305 12.5C3.00305 14.7543 3.89858 16.9163 5.49264 18.5104C7.0867 20.1045 9.24871 21 11.5031 21C13.7574 21 15.9194 20.1045 17.5135 18.5104C19.1075 16.9163 20.0031 14.7543 20.0031 12.5Z",
    fill: "#646397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.96113ab58e5d953e1843b2a9c48df3b2.svg";
export { ForwardRef as ReactComponent };